var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoadingIconBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "end icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 41440560"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 182",
    x: 10.5713,
    y: 2,
    width: 2,
    height: 6,
    rx: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 183",
    x: 10.5708,
    y: 16.2856,
    width: 2,
    height: 6,
    rx: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 184",
    x: 21.7139,
    y: 11.1431,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(90 21.7139 11.1431)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 185",
    x: 7.42822,
    y: 11.1426,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(90 7.42822 11.1426)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 186",
    x: 19.4502,
    y: 18.6079,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(135 19.4502 18.6079)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 187",
    x: 9.34912,
    y: 8.50635,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(135 9.34912 8.50635)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 188",
    x: 18.0366,
    y: 4.26416,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(45 18.0366 4.26416)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 189",
    x: 7.93457,
    y: 14.3652,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(45 7.93457 14.3652)",
    fill: "black"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoadingIconBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loading-icon-black.9f07b7b7b56c40a7e3040e5e19a33b91.svg";